<template>
    <div style="transition: all 0.2s; position: relative;" ref="interaction" @touchstart="touchStart" @touchend="touchEnd">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'InteractionOfScale',
    props: {
        scaleNumber: {
            type: String,
            default: '0.98'
        },
        isStopInteraction: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            touchTimer: null
        }
    },
    methods: {
        // 즉시 인터랙션 적용X => 0.2초뒤에 인터랙션 적용
        // touchStart() {
        //     this.touchTimer = setTimeout(() => {
        //         if (this.$refs.interaction) {
        //             this.$refs.interaction.style.scale = '0.98';
        //         }
        //     }, 200);
        // },
        // touchEnd() {
        //     clearTimeout(this.touchTimer);
        //     if (this.$refs.interaction) {
        //         this.$refs.interaction.style.scale = '1';
        //     }
        // }
        touchStart() {
            if (this.isStopInteraction) {
                return
            }
            this.$refs.interaction.style.transform = `scale(${this.scaleNumber})`;
        },
        touchEnd() {
            if (this.isStopInteraction) {
                return
            }
            this.$refs.interaction.style.transform = 'scale(1)';
            this.$refs.interaction.style.transform = 'none'
        }
    }
}
</script>

<style scoped></style>